import { Colors } from "@brg/ui";
import { LayoutConst } from "core";
import styled from "styled-components";

export const UnavailablePageWrapperOuter = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    justify-content: center;
    height: 100%;
    max-height: 100vh;
    overflow: hidden;

    @media screen and (max-width: ${LayoutConst.screen.sm}px) {
        font-size: 108px;
        line-height: 104px;
    }
`

export const UnavailablePageWrapper = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    @media screen and (max-width: ${LayoutConst.screen.mac13}px) {
        margin-top: 88px;
    }

    @media screen and (max-width: ${LayoutConst.screen.sm}px) {
        margin-top: 0;
    }
`

export const UnavailablePageNumber = styled.div`
    user-select: none;
    font-family: Inter;
    font-size: 250px;
    font-weight: 600;
    line-height: 250px;
    letter-spacing: -0.065em;
    text-align: justified;
    color: ${p => p.theme.errorPage.notFound.number};

    @media screen and (max-width: ${LayoutConst.screen.mac13}px) {
        font-size: 200px;
        line-height: 200px;
    }

    @media screen and (max-width: ${LayoutConst.screen.sm}px) {
        font-size: 108px;
        line-height: 104px;
    }
`

export const UnavailablePageTitle = styled.div`
    user-select: none;
    font-family: Inter;
    font-size: 30px;
    font-weight: 600;
    line-height: 40px;
    letter-spacing: -0.02em;
    text-align: center;
    color: ${p => p.theme.errorPage.notFound.title};

    @media screen and (max-width: ${LayoutConst.screen.mac13}px) {
        line-height: 27px;
        font-size: 23px;
    }

    @media screen and (max-width: ${LayoutConst.screen.sm - 1}px) {
        font-size: 20px;
        line-height: 25px;
    }
`

export const UnavailablePageDescription = styled.div`
    margin: 16px 0 40px;
    user-select: none;
    font-family: Inter;
    font-size: 17px;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: -0.02em;
    white-space: pre-line;
    text-align: center;
    color: ${p => p.theme.errorPage.notFound.title};

    @media screen and (max-width: ${LayoutConst.screen.mac13}px) {
        margin: 12px 0 32px;
        font-size: 15px;
    }

    @media screen and (max-width: ${LayoutConst.screen.s}px) {
        margin: 8px 0 24px;
    }
    
    @media screen and (max-width: ${LayoutConst.screen.s - 1}px) {
        font-size: 13px;
        line-height: 16px;
    }

`

export const UnavailablePageButtons = styled.div`
    display: flex;
    justify-content: center;
    gap: 24px;

    @media screen and (max-width: ${LayoutConst.screen.mac13}px) {
        gap: 16px;
    }

    @media screen and (max-width: ${LayoutConst.screen.s - 1}px) {
        flex-direction: column;
        gap: 8px;
    }
`

export const BackButton = styled.div`
    cursor: pointer;
    border: 1px solid ${p => p.theme.errorPage.buttons.border};
    color: ${p => p.theme.errorPage.buttons.hollowText};
    padding: 12px 48px;

    font-family: Inter;
    font-size: 17px;
    font-weight: 600;
    line-height: 22px;
    letter-spacing: -0.02em;
    text-align: center;
    border-radius: 3px;

    @media screen and (max-width: ${LayoutConst.screen.mac13}px) {
        font-size: 15px;
    }
`

export const MainButton = styled.div`
    cursor: pointer;
    background-color: ${p => p.theme.errorPage.buttons.bg};
    color: ${p => p.theme.errorPage.buttons.filledText};
    padding: 12px 48px;

    font-family: Inter;
    font-size: 17px;
    font-weight: 600;
    line-height: 22px;
    letter-spacing: -0.02em;
    text-align: center;
    border-radius: 3px;

    @media screen and (max-width: ${LayoutConst.screen.mac13}px) {
        font-size: 15px;
    }
`import { Colors } from "@brg/ui";
import { LayoutConst } from "core";
import styled from "styled-components";

export const UnavailablePageWrapperOuter = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    justify-content: center;
    height: 100%;
    max-height: 100vh;
    overflow: hidden;

    @media screen and (max-width: ${LayoutConst.screen.sm}px) {
        font-size: 108px;
        line-height: 104px;
    }
`

export const UnavailablePageWrapper = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    @media screen and (max-width: ${LayoutConst.screen.mac13}px) {
        margin-top: 88px;
    }

    @media screen and (max-width: ${LayoutConst.screen.sm}px) {
        margin-top: 0;
    }
`

export const UnavailablePageNumber = styled.div`
    user-select: none;
    font-family: Inter;
    font-size: 250px;
    font-weight: 600;
    line-height: 250px;
    letter-spacing: -0.065em;
    text-align: justified;
    color: ${p => p.theme.errorPage.notFound.number};

    @media screen and (max-width: ${LayoutConst.screen.mac13}px) {
        font-size: 200px;
        line-height: 200px;
    }

    @media screen and (max-width: ${LayoutConst.screen.sm}px) {
        font-size: 108px;
        line-height: 104px;
    }
`

export const UnavailablePageTitle = styled.div`
    user-select: none;
    font-family: Inter;
    font-size: 30px;
    font-weight: 600;
    line-height: 40px;
    letter-spacing: -0.02em;
    text-align: center;
    color: ${p => p.theme.errorPage.notFound.title};

    @media screen and (max-width: ${LayoutConst.screen.mac13}px) {
        line-height: 27px;
        font-size: 23px;
    }

    @media screen and (max-width: ${LayoutConst.screen.sm - 1}px) {
        font-size: 20px;
        line-height: 25px;
    }
`

export const UnavailablePageDescription = styled.div`
    margin: 16px 0 40px;
    user-select: none;
    font-family: Inter;
    font-size: 17px;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: -0.02em;
    white-space: pre-line;
    text-align: center;
    color: ${p => p.theme.errorPage.notFound.title};

    @media screen and (max-width: ${LayoutConst.screen.mac13}px) {
        margin: 12px 0 32px;
        font-size: 15px;
    }

    @media screen and (max-width: ${LayoutConst.screen.s}px) {
        margin: 8px 0 24px;
    }
    
    @media screen and (max-width: ${LayoutConst.screen.s - 1}px) {
        font-size: 13px;
        line-height: 16px;
    }

`

export const UnavailablePageButtons = styled.div`
    display: flex;
    justify-content: center;
    gap: 24px;

    @media screen and (max-width: ${LayoutConst.screen.mac13}px) {
        gap: 16px;
    }

    @media screen and (max-width: ${LayoutConst.screen.s - 1}px) {
        flex-direction: column;
        gap: 8px;
    }
`

export const BackButton = styled.div`
    cursor: pointer;
    border: 1px solid ${p => p.theme.errorPage.buttons.border};
    color: ${p => p.theme.errorPage.buttons.hollowText};
    padding: 12px 48px;

    font-family: Inter;
    font-size: 17px;
    font-weight: 600;
    line-height: 22px;
    letter-spacing: -0.02em;
    text-align: center;
    border-radius: 3px;

    @media screen and (max-width: ${LayoutConst.screen.mac13}px) {
        font-size: 15px;
    }
`

export const MainButton = styled.div`
    cursor: pointer;
    background-color: ${p => p.theme.errorPage.buttons.bg};
    color: ${p => p.theme.errorPage.buttons.filledText};
    padding: 12px 48px;

    font-family: Inter;
    font-size: 17px;
    font-weight: 600;
    line-height: 22px;
    letter-spacing: -0.02em;
    text-align: center;
    border-radius: 3px;

    @media screen and (max-width: ${LayoutConst.screen.mac13}px) {
        font-size: 15px;
    }
`